import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import anuKingdomLogo from '../assets/images/anu-kingdom-logo.webp';
import './Auth.css';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      navigate('/login?error=' + error);
      return;
    }

    if (token) {
      // Store token and fetch user data
      localStorage.setItem('token', token);

      const fetchUser = async () => {
        try {
          const response = await api.get('/auth/me');
          localStorage.setItem('user', JSON.stringify(response.data));
          window.location.href = '/';
        } catch (error) {
          console.error('Error fetching user:', error);
          navigate('/login?error=fetch_failed');
        }
      };

      fetchUser();
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div className="auth-page">
      <Link to="/" className="auth-brand" aria-label="Anu Kingdom home">
        <img src={anuKingdomLogo} alt="Anu Kingdom" />
        <span>ANU KINGDOM</span>
        <small>Learning Platform</small>
      </Link>
      <div className="auth-container">
        <h2>Authenticating...</h2>
        <p>Please wait while we log you in.</p>
      </div>
    </div>
  );
};

export default AuthCallback;
